module.exports = __webpack_public_path__ + "static/media/location.a24d7b99.svg";